import { useMutation } from '@apollo/client';
import { UPDATE_SAVED_SEARCH } from '@general/graphql/saved-searches.graph';

const useEditSavedSearch = () => {
    const [updateSavedSearch] = useMutation(UPDATE_SAVED_SEARCH);
    return { updateSavedSearch };
};

export default useEditSavedSearch;
